import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamDeleteRequestDTORaw) {
    JsonSchemaValidator.assert(RoomStreamDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamDeleteRequestDTORaw {
  roomId: RoomId;
  streamId: StreamId;
}
